import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function InvoicelineReducer(state = initialState.invoiceline, action: any) {
  switch (action.type) {
    case types.SAVE_INVOICELINE_SUCCESS:
      return action.invoiceline;
    default:
      return state;
  }
}
